import { FC } from 'react';

import { IconProps } from '../types';

const EasyAndConvenientIcon: FC<IconProps> = ({ size, ...props }) => (
  <svg
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    {...props}
    aria-hidden="true"
  >
    <path
      d="M22.1619 31.2371L24.0316 23.1345H32.4536C33.0958 23.1483 33.7206 22.9257 34.2094 22.5092C34.6983 22.0926 35.0171 21.511 35.1054 20.8748C35.1418 20.5238 35.1041 20.1691 34.9947 19.8336C34.8854 19.4982 34.7067 19.1894 34.4704 18.9273C34.2341 18.6653 33.9454 18.4558 33.623 18.3124C33.3006 18.169 32.9516 18.095 32.5988 18.095H15.1358C14.9432 18.0948 14.7547 18.0395 14.5926 17.9355C14.4305 17.8315 14.3015 17.6833 14.2211 17.5083C14.1406 17.3333 14.1119 17.139 14.1384 16.9482C14.165 16.7575 14.2456 16.5783 14.3708 16.432L18.3248 11.8188C18.7553 11.3158 18.9919 10.6756 18.992 10.0136C18.9922 9.48318 18.8402 8.96383 18.5541 8.51717C18.268 8.07052 17.8598 7.7153 17.3779 7.49366C16.896 7.27202 16.3606 7.19325 15.8353 7.26671C15.31 7.34017 14.8167 7.56276 14.4141 7.90809L4.88135 16.0792V24.1424V32.2057L16.0288 34.9925C16.6783 35.155 17.3537 35.1864 18.0155 35.0849C18.6772 34.9834 19.3122 34.751 19.8832 34.4014C20.4541 34.0518 20.9497 33.5919 21.341 33.0486C21.7322 32.5053 22.0113 31.8895 22.1619 31.2371Z"
      stroke="#030303"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M32.0947 5L27.0552 10.0395"
      stroke="#030303"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23.0234 9.03162L24.0313 5"
      stroke="#030303"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M28.0635 14.0711L32.0951 13.0632"
      stroke="#030303"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default EasyAndConvenientIcon;
